import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "headerRoot", "topBelt", "logo", "nav", "body",
        "clinicList", "clinicListTrigger", "closeClinicListButton",
        "contactNumbers", "contactNumbersTrigger", "closeContactNumbersButton"
    ]

    connect() {
        this.hamburgerNav = this.navTarget.querySelector('.js-menu-top-menu-container')
        const observer = new IntersectionObserver(
            ([e]) => {
                const force = e.intersectionRatio < 1;
                this.topBeltTarget.classList.toggle("py-2", force)
                this.logoTarget.setAttribute('height', force ? 60.75 : 81)
                this.logoTarget.setAttribute('width', force ? 132.75 : 177)
                this.headerRootTarget.classList.toggle('border-b-2', force)
                this.headerRootTarget.querySelectorAll('.enhanced-menu-top-menu > .menu-item > .sub-menu').forEach((el) => {
                    el.classList.toggle('stickied', force)
                })
            },
            { threshold: [1] }
        );

        observer.observe(this.headerRootTarget)

        this.headerRootTarget.querySelectorAll('.enhanced-menu-top-menu > .menu-item.menu-item-has-children').forEach(el => {
            el.addEventListener('click', () => {
                el.querySelector('ul.sub-menu').classList.toggle('!block')
            })
        })

        this.bodyTarget.addEventListener('click', (e) => {
            if (this.clinicListTarget.contains(e.target) || this.clinicListTriggerTarget.contains(e.target)
                || this.contactNumbersTarget.contains(e.target) || this.contactNumbersTriggerTarget.contains(e.target)) return;

            this.closeClinicList()
            this.closeContactNumbers()
        });
    }

    // Hamburger nav
    openHamburgerNav() {
        this.hamburgerNav.classList.toggle('h-offset-all-belts')
    }

    toggleHeight(target) {
        target.classList.toggle('h-offset-top-belt')
        target.classList.toggle("lg:h-[750px]")
    }

    removeHeight(target) {
        target.classList.remove('h-offset-top-belt')
        target.classList.remove("lg:h-[750px]")

    }

    closeClinicList() {
        this.removeHeight(this.clinicListTarget)
        this.closeClinicListButtonTarget.classList.add('hidden')
        this.clinicListTriggerTarget.querySelectorAll('svg')[1].classList.remove("rotate-180")
    }

    closeContactNumbers() {
        this.removeHeight(this.contactNumbersTarget)
        this.closeContactNumbersButtonTarget.classList.add('hidden')
        this.contactNumbersTriggerTarget.querySelectorAll('svg')[1].classList.remove("rotate-180")
    }

    openClinicList() {
        this.toggleHeight(this.clinicListTarget)
        this.clinicListTriggerTarget.querySelectorAll('svg')[1].classList.toggle("rotate-180")
        this.closeContactNumbers()

        if (this.clinicListTarget.classList.contains("h-offset-top-belt")) {
            this.closeClinicListButtonTarget.classList.remove('hidden')
        } else {
            this.closeClinicListButtonTarget.classList.add('hidden')
        }
    }

    openContactNumbers() {
        this.toggleHeight(this.contactNumbersTarget)
        this.contactNumbersTriggerTarget.querySelectorAll('svg')[1].classList.toggle("rotate-180")
        this.closeClinicList()

        if (this.contactNumbersTarget.classList.contains("h-offset-top-belt")) {
            this.closeContactNumbersButtonTarget.classList.remove('hidden')
        } else {
            this.closeContactNumbersButtonTarget.classList.add('hidden')
        }
    }
}